import { render, staticRenderFns } from "./Council.vue?vue&type=template&id=190ae33a&scoped=true&"
import script from "./Council.vue?vue&type=script&lang=js&"
export * from "./Council.vue?vue&type=script&lang=js&"
import style0 from "./Council.vue?vue&type=style&index=0&id=190ae33a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "190ae33a",
  null
  
)

export default component.exports